"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("../styles");
const styles = styles_1.createStyles(({ palette, shape, spacing }) => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        borderRadius: shape.borderRadius,
        border: `1px solid ${palette.error}`,
        backgroundColor: palette.lighter('error'),
        padding: spacing(1),
    },
    message: {
        flex: 1,
        whiteSpace: 'normal',
        color: palette.error,
        margin: 0,
    },
}));
exports.decorate = styles_1.withStyles(styles);
